"use client";

import NotFoundPage from "@/page-components/NotFoundPage";

export default function NotFound() {
  return <NotFoundPage />;
}
